module.exports = __webpack_public_path__ + "img/sp_eyecatch01.8d6ff210.jpg";